import { Component, OnInit, Injector } from '@angular/core';
import { Auth } from 'aws-amplify';
import { AlertService } from '../../../shared/services/alert.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-new-password-modal',
  templateUrl: './new-password-modal.component.html',
  styleUrls: ['./new-password-modal.component.css']
})
export class NewPasswordModalComponent extends ModalBaseComponent implements OnInit {
  

  constructor(private inject: Injector, private alertService:AlertService,
    private _bsModalRef: BsModalRef,
    private router: Router,
    private route: ActivatedRoute) {
      super(inject);
     }

  ngOnInit() {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/main';
  }
  returnUrl: string;
  password1: string;
  password2: string;
  user: any;
  errorMessage: string;

  resetPassword(){
    this.errorMessage = '';
    if(this.password1 === this.password2){
      Auth.completeNewPassword(this.user, this.password1, this.user.challengeParam.requiredAttributes)
      .then(user => {
        sessionStorage.setItem('token', user.authKey);
        this.closeModal();
        this.router.navigate([this.returnUrl]);
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        this.errorMessage = error.message;
      });
    }else {
      this.errorMessage = 'passwords dont match';
    }
   
  }

    //call this whenever you want to close modal
    public closeModal(): void {
      this._bsModalRef.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/new-password-modal/new-password-modal.component.ts